<template>
  <v-app class="page-cont">
    <Header />
    <!-- isn't registered yet -->
    <main id="main-content" tabindex="-1">
      <div v-if="registered == false">
        <!-- is a in person sale -->
        <div class="registration">
          <div class="box">
            <h1>Register Your 2026-2027 Snow Canyon Desert Discovery Pass</h1>
            <p>Carefully enter your info to finish registration.</p>
          </div>
          <div class="registration-inside">
            <div class="box box-image">
              <img
                style="width: 300px"
                src="../assets/images/desert-discovery.png"
                alt=""
              />
              <div style="display: flex; flex-direction: column">
                <h2>Pass Number</h2>
                <h6>* Required Information</h6>
                <v-text-field
                  label="* Example: 1234"
                  aria-required="true"
                  v-model="serial_number"
                  filled
                  dense
                  color="primary"
                  error-color="#D0021B"
                  :error="!!serialError"
                  :error-messages="serialError"
                  @input="clearSerialError"
                  @blur="validateSerialField"
                  :persistent-hint="!serialError"
                  background-color="grey lighten-4"
                  class="reg-textfield"
                  :hint="
                    emailError
                      ? ''
                      : 'This is found under the QR code on your physical pass.'
                  "
                />
              </div>
            </div>
            <div class="box">
              <h2>Pass Number</h2>
              <h6>* Required Information</h6>
              <v-text-field
                label="* Email"
                aria-required="true"
                v-model="email"
                filled
                dense
                color="primary"
                error-color="#D0021B"
                :error="!!emailError"
                :error-messages="emailError"
                @input="clearEmailError"
                @blur="validateEmailField"
                :persistent-hint="!emailError"
                background-color="grey lighten-4"
                class="reg-textfield"
                :hint="
                  emailError
                    ? ''
                    : 'We\'ll use this to send your registration confirmation.'
                "
              />
            </div>

            <div class="box">
              <h2>Zip Code</h2>
              <v-text-field
                label="* Zip Code"
                aria-required="true"
                v-model="zip"
                filled
                dense
                color="primary"
                error-color="#D0021B"
                :error="!!zipError"
                :error-messages="zipError"
                @input="clearZipError"
                @blur="validateZipField"
                persistent-hint
                background-color="grey lighten-4"
                class="reg-textfield"
              />
            </div>

            <div class="box">
              <h2>License Plates</h2>
              <p>
                Include all vehicles covered by this pass. Park employees will
                use these plates to verify your pass at the park.
              </p>
              <div class="side-flex" @click="returning = true">
                <img class="add-icon" src="../assets/icons/add.svg" alt="" />
                <p class="green-text" style="cursor: pointer">
                  Add license plate(s) from a previously registered pass.
                </p>
              </div>
              <v-text-field
                label="License Plate 1"
                aria-required="true"
                v-model="license_plate1"
                filled
                dense
                color="primary"
                error-color="#D0021B"
                :error="!!licensePlate1Error"
                :error-messages="licensePlate1Error"
                @input="clearLicensePlate1Error"
                @blur="validateLicensePlate1Field"
                persistent-hint
                background-color="grey lighten-4"
                class="reg-textfield"
              />
              <v-text-field
                label="License Plate 2"
                v-model="license_plate2"
                filled
                dense
                color="primary"
                persistent-hint
                background-color="grey lighten-4"
                class="reg-textfield"
                style="margin-top: 0px"
              />
              <v-text-field
                label="License Plate 3"
                v-model="license_plate3"
                filled
                dense
                color="primary"
                persistent-hint
                background-color="grey lighten-4"
                class="reg-textfield"
                style="margin-top: 0px"
              />
            </div>

            <div class="box">
              <h2>Pass Type</h2>
              <p>* Are you 65 or older?</p>
              <v-radio-group
                v-model="senior"
                id="radio-group"
                error-color="#D0021B"
                :error="!!seniorError"
                :error-messages="seniorError"
                @change="clearSeniorError"
              >
                <v-radio
                  class="select-radio"
                  label="Yes"
                  value="true"
                  color="#0096FF"
                ></v-radio>
                <v-radio
                  class="select-radio"
                  label="No"
                  value="false"
                  color="#0096FF"
                ></v-radio>
              </v-radio-group>
            </div>

            <!-- Error Alert Banner -->
            <div class="box-clear" v-if="showErrorBanner">
              <div class="custom-error-banner">
                <div class="error-content">
                  <v-icon class="error-icon">mdi-alert-circle-outline</v-icon>
                  <span class="error-text2">Missing required fields.</span>
                </div>
                <v-icon class="close-icon" @click="showErrorBanner = false"
                  >mdi-close</v-icon
                >
              </div>
            </div>

            <div class="box-clear">
              <div class="button-cont">
                <button
                  class="green-button"
                  @click="handleSubmit"
                  :disabled="isSubmitting"
                >
                  {{ isSubmitting ? "Saving..." : "Finish & Save" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- is already registered -->
      <div v-else class="after-registration">
        <div id="left">
          <div id="top">
            <img
              id="top-check"
              src="../assets/icons/blue-checkmark.svg"
              alt="blue checkmark"
            />
            <h1>Your pass is registered.</h1>
            <p>Pass expires: {{ pass.expiration }}</p>
            <v-divider id="top-divider"></v-divider>
            <div class="side-flex" style="margin-bottom: 50px">
              <h3>
                Order Number: <span id="bold-top">{{ pass.order_number }}</span>
              </h3>
              <button class="copy-button" @click="copyOrderNumber">
                <img src="../assets/icons/copy.svg" alt="" />Copy
              </button>
            </div>
          </div>
          <div id="bottom">
            <img
              src="../assets/images/app-logo.svg"
              alt="app icon"
              id="app-icon"
            />
            <h1 id="bottom-h1">
              Keep your Desert Discovery Pass on your Phone
            </h1>
            <div class="app-cont" @click="goToIOS()">
              <p class="tiny-text">IOS</p>
              <img src="../assets/images/apple.png" alt="apple store button" />
            </div>
            <div class="app-cont" @click="goToAndroid()">
              <p class="tiny-text">Android</p>
              <img
                src="../assets/images/google.png"
                alt="google play store button"
              />
            </div>
            <h3 id="info-p">
              Keep your Snow Canyon Desert Discovery pass on your phone with the
              Utah State Parks app. The app uses a QR code for easy entrance
              into Utah’s State Parks. Never stress about losing your pass. Keep
              it on your phone.
            </h3>
            <div id="deeplink-cont">
              <h2 id="deeplink-head">Already have the app?</h2>
              <p id="deeplink-p">
                You can have your pass automatically download by clicking the
                button below!
              </p>
              <button id="deeplink-button" @click="deeplink()">
                Add Pass to App
              </button>
            </div>
          </div>
        </div>
        <!-- <div id="right">
        <h1>Park Stamps</h1>
        <p>This pass was last seen at:</p>
        <v-divider class="stamp-divider"></v-divider>
        <div v-if="FinalHistory.length > 0">
          <div
            v-for="visit in FinalHistory"
            :key="visit.park"
            class="stamp-cont"
          >
            <img
              :src="require(`@/assets/ShowIcons/${visit.park}.png`)"
              alt=""
              class="stamp"
            />
            <h6 class="stamp-date">{{ visit.date }}</h6>
          </div>
        </div>
        <div v-else>
          <h3 id="no-stamps">Visit a park and earn a stamp!</h3>
        </div>
      </div> -->
      </div>
    </main>

    <!-- returning customer dialog/popup -->
    <v-dialog v-model="returning" width="90%" max-width="700px">
      <v-card class="info-card">
        <div class="flex-end">
          <img
            @click="returning = false"
            src="../assets/icons/close.svg"
            alt=""
          />
        </div>
        <div id="dialog-cont">
          <h1>Find a Previous Pass Registration</h1>
          <p class="dialog-h2">
            Retrieve your old registration to reuse license plates.
          </p>
          <!-- search bar needed here -->
          <div class="search-field-container">
            <v-icon class="search-icon-left">mdi-magnify</v-icon>
            <input
              v-model="old_order_number"
              type="text"
              placeholder="Order or serial #"
              class="search-input-inline"
              @keyup.enter="handleOrderLookupByOrderNum"
            />
            <button
              class="search-button-inline"
              @click="handleOrderLookupByOrderNum"
              :disabled="isSubmitting || !old_order_number"
            >
              {{ isSubmitting ? "Searching..." : "Find Pass" }}
            </button>
          </div>
          <div class="side-flex" style="margin-bottom: 5px">
            <img src="../assets/icons/ordernum.svg" alt="" />
            <p class="dialog-h6">
              <span class="heavy">Order number:</span> in your email from
              Parkspass
            </p>
          </div>
          <div class="side-flex">
            <img src="../assets/icons/serialnum.svg" alt="" />
            <p class="dialog-h6">
              <span class="heavy">Serial number:</span> on the back of your
              physical annual pass.
            </p>
          </div>

          <!-- if there are search results -->
          <div v-if="searchResults == true">
            <p class="heavy-2">Search Results</p>
            <div id="result-box">
              <div id="result-head">
                <p class="dialog-h2" style="margin-bottom: 0px">
                  Order Number: {{ pass.order_number }}
                </p>
              </div>
              <div id="result-body">
                <div
                  v-if="pass.license_plate"
                  class="plate-row"
                  @click="togglePlate(1)"
                >
                  <p class="plate-text">
                    License Plate 1: {{ pass.license_plate }}
                  </p>
                  <div class="plate-action">
                    <img
                      v-if="!isPlateSelected(1)"
                      src="../assets/icons/add.svg"
                      alt=""
                      class="action-icon"
                    />
                    <img
                      v-else
                      src="../assets/icons/check.svg"
                      alt=""
                      class="action-icon"
                    />
                    <p
                      :class="
                        isPlateSelected(1)
                          ? 'action-text-selected'
                          : 'action-text'
                      "
                    >
                      {{
                        isPlateSelected(1) ? "Plate Added" : "Add this plate"
                      }}
                    </p>
                  </div>
                </div>

                <div
                  v-if="pass.license_plate2"
                  class="plate-row"
                  @click="togglePlate(2)"
                >
                  <p class="plate-text">
                    License Plate 2: {{ pass.license_plate2 }}
                  </p>
                  <div class="plate-action">
                    <img
                      v-if="!isPlateSelected(2)"
                      src="../assets/icons/add.svg"
                      alt=""
                      class="action-icon"
                    />
                    <img
                      v-else
                      src="../assets/icons/check.svg"
                      alt=""
                      class="action-icon"
                    />
                    <p
                      :class="
                        isPlateSelected(2)
                          ? 'action-text-selected'
                          : 'action-text'
                      "
                    >
                      {{
                        isPlateSelected(2) ? "Plate Added" : "Add this plate"
                      }}
                    </p>
                  </div>
                </div>

                <div
                  v-if="pass.license_plate3"
                  class="plate-row"
                  @click="togglePlate(3)"
                >
                  <p class="plate-text">
                    License Plate 3: {{ pass.license_plate3 }}
                  </p>
                  <div class="plate-action">
                    <img
                      v-if="!isPlateSelected(3)"
                      src="../assets/icons/add.svg"
                      alt=""
                      class="action-icon"
                    />
                    <img
                      v-else
                      src="../assets/icons/check.svg"
                      alt=""
                      class="action-icon"
                    />
                    <p
                      :class="
                        isPlateSelected(3)
                          ? 'action-text-selected'
                          : 'action-text'
                      "
                    >
                      {{
                        isPlateSelected(3) ? "Plate Added" : "Add this plate"
                      }}
                    </p>
                  </div>
                </div>

                <!-- Add Apply button -->
                <div class="button-cont" style="margin-top: 20px">
                  <button
                    class="green-button"
                    @click="applySelectedPlates"
                    :disabled="selectedPlates.length === 0"
                  >
                    Continue with these plates
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- if there are no search results -->
          <div v-else-if="noSearchResults == true">
            <p class="heavy-2">Search Results</p>
            <div class="center-flex">
              <img src="../assets/icons/no-search.svg" alt="" />
              <h2 id="no-search-h2">No Registration Found</h2>
              <h5 id="no-search-h5">
                We can't find any registration matching your search
              </h5>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import $ from "jquery";
import Header from "@/components/Header.vue";

export default {
  data() {
    return {
      registered: false,
      pass: {},
      serial_number: "",
      orderNumber: "", // You can pull this from route or API
      senior: null,
      returning: false,
      online: true,
      email: "",
      zip: "",
      license_plate1: "",
      license_plate2: "",
      license_plate3: "",
      old_order_number: "",

      // Error handling
      showErrorBanner: false,
      isSubmitting: false,
      emailError: "",
      zipError: "",
      licensePlate1Error: "",
      seniorError: "",
      orderError: "",
      oldFound: false,
      searchResults: false,
      noSearchResults: false,
      selectedPlates: [],
      FinalHistory: [],
      shopify_order_number: "",
      shopify_license: "",
      shopifyOrderError: "",
      shopifyLicenseError: "",
      isSubmittingShopify: false,
      sale_date: "",
      serialError: "",
    };
  },

  components: {
    Header,
  },

  created() {},

  methods: {
    submitRegistration() {
      // submit registration data to API
      console.log("submitting registration");
      console.log({
        barcode: this.serial_number,
        email: this.email,
        zip: this.zip,
        lp1: this.license_plate1,
        lp2: this.license_plate2,
        lp3: this.license_plate3,
        senior: this.senior,
        sale_date: this.sale_date,
      });
      var settings = {
        url: `https://trailwaze.info/parkspass/api/addMAnnualPass_new.php?barcode=${this.serial_number}&email=${this.email}&zip=${this.zip}&lp1=${this.license_plate1}&lp2=${this.license_plate2}&lp3=${this.license_plate3}&senior=${this.senior}&sale_date=${this.sale_date}`,
        method: "GET",
        timeout: 0,
        headers: {
          PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
        },
        dataType: "json",
      };
      var _this = this;
      $.ajax(settings).done(function (response) {
        console.log(response);
        if (response.result3 == "success") {
          //alert("Registration successful!");
          console.log("registration successful");
          // show the info page
          _this.grabRegistration(response.order_number);
          //window.location.reload();
        } else {
          alert(
            "There was an error submitting your registration. please try again."
          );
        }
      });
    },
    submitOnlineRegistration() {
      // submit online registration data to API
      console.log("submitting online registration");
      var settings = {
        url: `https://trailwaze.info/parkspass/api/addMAnnualBarcode.php?order_number=${this.shopify_order_number}&barcode=${this.serial_number}&lp1=${this.shopify_license}`,
        method: "GET",
        timeout: 0,
        headers: {
          PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
        },
        dataType: "json",
      };

      $.ajax(settings).done(function (response) {
        console.log(response);
        if (response.result == "success") {
          console.log("online registration successful");
          window.location.reload();
        } else {
          alert(
            "There was an error submitting your registration. please try again."
          );
        }
      });
    },
    checkSale() {
      var _this = this;
      console.log("checking sale for serial number:", this.serial_number);
      var settings = {
        url: `https://trailwaze.info/parkspass/api/searchMAnnualPassSale.php?barcode=${this.serial_number}`,
        method: "GET",
        timeout: 0,
        headers: {
          PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
        },
        dataType: "json",
      };
      $.ajax(settings).done(function (response) {
        console.log("sale scan data", response);
        if (response.length == 0) {
          // wasn't scanned when sold (stolen??)
          console.log("no sale data found");
          console.log("stolen!!!!");
          // will eventually redirect to a zendesk form when dallin creates it.
          //_this.$router.push(`/stolenpass/${_this.serial_number}`);
          _this.checkRegistration(_this.serial_number);
          _this.sale_date = new Date().toISOString().split("T")[0]; // Formats date as "YYYY-MM-DD"
        } else {
          console.log("sale data found");
          // was sold so move to registration
          _this.sale_date = response[0].registration_date;
          if (new Date(_this.sale_date) < new Date("2026-01-01")) {
            _this.sale_date = "2026-01-01";
          }

          // maybe check if its already registered
          _this.checkRegistration(_this.serial_number);
        }
      });
    },
    checkIfOnlineOrInPerson() {
      var _this = this;
      var settings = {
        url: `https://trailwaze.info/parkspass/api/searchMAnnualPassSale.php?barcode=${this.serial_number}`,
        method: "GET",
        timeout: 0,
        headers: {
          PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
        },
        dataType: "json",
      };

      $.ajax(settings).done(function (response) {
        console.log("sale scan data", response);
        if (response.length == 0) {
          // wasn't scanned when sold (stolen??)
          console.log("no sale data found");
          console.log("stolen!!!!");
          // will eventually redirect to a zendesk form when dallin creates it.
          _this.$router.push(`/stolenpass/${_this.serial_number}`);
        } else {
          if (response[0].park_abbr == "PKPASS") {
            _this.online = true;
            console.log("online sale detected");
          } else {
            _this.online = false;
            console.log("in person sale detected");
          }
        }
      });
    },
    validateShopifyOrderField() {
      if (!this.shopify_order_number) {
        this.shopifyOrderError = "Order number is required";
      } else if (this.shopify_order_number.trim().length === 0) {
        this.shopifyOrderError = "Order number cannot be empty";
      }
    },

    validateShopifyLicenseField() {
      if (!this.shopify_license) {
        this.shopifyLicenseError = "License plate is required";
      } else if (
        this.shopify_license.length < 2 ||
        this.shopify_license.length > 8
      ) {
        this.shopifyLicenseError = "License plate must be 2-8 characters";
      }
    },
    validateSerialField() {
      if (!this.serial_number) {
        this.serialError = "Serial number is required";
      } else if (this.serial_number.trim().length === 0) {
        this.serialError = "Serial number cannot be empty";
      } else if (this.serial_number.length < 4) {
        this.serialError = "Serial number must be at least4 characters";
      }
    },

    clearSerialError() {
      this.serialError = "";
    },

    validateShopifyForm() {
      let isValid = true;

      // Reset errors
      this.shopifyOrderError = "";
      this.shopifyLicenseError = "";
      this.showErrorBanner = false;

      // Validate order number
      if (!this.shopify_order_number) {
        this.shopifyOrderError = "Order number is required";
        isValid = false;
      } else if (this.shopify_order_number.trim().length === 0) {
        this.shopifyOrderError = "Order number cannot be empty";
        isValid = false;
      }

      // Validate license plate
      if (!this.shopify_license) {
        this.shopifyLicenseError = "License plate is required";
        isValid = false;
      } else if (
        this.shopify_license.length < 2 ||
        this.shopify_license.length > 8
      ) {
        this.shopifyLicenseError = "License plate must be 2-8 characters";
        isValid = false;
      }

      // Show error banner if validation fails
      if (!isValid) {
        this.showErrorBanner = true;
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      return isValid;
    },
    async copyOrderNumber() {
      try {
        await navigator.clipboard.writeText(this.pass.order_number);
        alert("Order number copied to clipboard!");
      } catch (err) {
        console.error("Failed to copy:", err);
        alert("Failed to copy order number");
      }
    },

    clearShopifyOrderError() {
      this.shopifyOrderError = "";
    },

    clearShopifyLicenseError() {
      this.shopifyLicenseError = "";
    },
    async handleSubmitShopify() {
      // Validate form
      if (!this.validateShopifyForm()) {
        return;
      }
      //   this.isSubmittingShopify = true;
      //   this.serial_number = "SNOW0" + this.serial_number;
      //   console.log("adjusted serial number: ", this.serial_number);

      // check to see if this pass was scanned for sale
      // no: pass stolen page
      // yes: check if it is already registered
      // yes: say this pass is already registered and show info
      // no: register the pass, then show pass info
      //this.submitOnlineRegistration();
    },
    deeplink() {
      this.$router.push(`/app/download/${this.pass.auth_code}`);
    },
    goToAndroid() {
      window.location.href =
        "http://play.google.com/store/apps/details?id=edu.utahtech.parkspass.utahstateparks";
    },
    goToIOS() {
      window.location.href =
        "https://apps.apple.com/us/app/utah-state-parks/id1638662132";
    },
    GetHistory(order_number) {
      // there is a current issue. This Endpoint takes too long and the browser shuts it down so it is not displaying the history.
      console.log("getting history");
      var settings = {
        url: `https://trailwaze.info/test/parkpass/checkinQRCode.php?order_number=${order_number}&action=status`,
        method: "GET",
        timeout: 0,
      };
      var _this = this;
      $.ajax(settings).done(function (response) {
        console.log(response);

        console.log("found history");
        console.log(response.data.check_in_activity);
        //_this.getUniqueParks(response.data.check_in_activity);
        _this.FinalHistory = _this.breakdownHistory(
          response.data.check_in_activity
        );
        console.log("Final History", _this.FinalHistory);
      });
    },
    breakdownHistory(historyList) {
      return historyList
        .map((item) => {
          const parts = item.split("-");
          const park = parts[0];
          const year = parts[1].slice(2); // Last two digits of the year
          const month = parts[2];
          const day = parts[3];
          const date = `${month}/${day}/${year}`;
          return { park, date };
        })
        .filter((entry) => entry.park !== "UNK" && entry.park !== "STICKR");
    },
    togglePlate(plateNumber) {
      const plateKey = `license_plate${plateNumber === 1 ? "" : plateNumber}`;
      const plateValue = this.pass[plateKey];

      if (!plateValue) return; // Don't toggle if plate is empty

      const index = this.selectedPlates.findIndex(
        (plate) => plate.key === plateKey
      );

      if (index > -1) {
        // Remove from selected
        this.selectedPlates.splice(index, 1);
      } else {
        // Add to selected
        this.selectedPlates.push({
          key: plateKey,
          value: plateValue,
          number: plateNumber,
        });
      }
    },

    isPlateSelected(plateNumber) {
      const plateKey = `license_plate${plateNumber === 1 ? "" : plateNumber}`;
      return this.selectedPlates.some((plate) => plate.key === plateKey);
    },

    applySelectedPlates() {
      // Apply selected plates to the form
      this.selectedPlates.forEach((plate) => {
        if (plate.number === 1) {
          this.license_plate1 = plate.value;
        } else if (plate.number === 2) {
          this.license_plate2 = plate.value;
        } else if (plate.number === 3) {
          this.license_plate3 = plate.value;
        }
      });

      // Close the dialog
      this.returning = false;
    },
    validateEmailOrPhone(value) {
      if (!value) return false;

      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // Phone validation (simple US format)
      const phoneRegex = /^[\d\s\-()]+$/;

      return (
        emailRegex.test(value) ||
        (phoneRegex.test(value) && value.replace(/\D/g, "").length >= 10)
      );
    },

    validateEmailField() {
      if (!this.email) {
        this.emailError = "Email or phone is required";
      } else if (!this.validateEmailOrPhone(this.email)) {
        this.emailError = "Please enter a valid email or phone number";
      }
    },

    validateZipField() {
      if (!this.zip) {
        this.zipError = "Zip code is required";
      } else if (!/^\d{5}(-\d{4})?$/.test(this.zip)) {
        this.zipError = "Please enter a valid zip code";
      }
    },

    validateLicensePlate1Field() {
      if (!this.license_plate1) {
        this.licensePlate1Error = "At least one license plate is required";
      } else if (
        this.license_plate1.length < 2 ||
        this.license_plate1.length > 8
      ) {
        this.licensePlate1Error = "License plate must be 2-8 characters";
      }
    },

    validateOrderField() {
      if (!this.old_order_number) {
        this.orderError = "Old order number is required";
      } else if (this.old_order_number.trim().length === 0) {
        this.orderError = "Old order number cannot be empty";
      }
    },

    validateForm() {
      let isValid = true;

      // Reset errors
      this.serialError = "";
      this.emailError = "";
      this.zipError = "";
      this.licensePlate1Error = "";
      this.seniorError = "";
      this.showErrorBanner = false;

      // Validate serial number
      if (!this.serial_number) {
        this.serialError = "Serial number is required";
        isValid = false;
      } else if (this.serial_number.trim().length === 0) {
        this.serialError = "Serial number cannot be empty";
        isValid = false;
      } else if (this.serial_number.length < 4) {
        this.serialError = "Serial number must be at least 4 characters";
        isValid = false;
      }

      // Validate email/phone
      if (!this.email) {
        this.emailError = "Email or phone is required";
        isValid = false;
      } else if (!this.validateEmailOrPhone(this.email)) {
        this.emailError = "Please enter a valid email or phone number";
        isValid = false;
      }

      // ... rest of existing validation code

      // Show error banner if validation fails
      if (!isValid) {
        this.showErrorBanner = true;
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      return isValid;
    },

    validateOrderForm() {
      let isValid = true;

      // Reset errors
      this.orderError = "";
      this.showErrorBanner = false;

      // Validate order number
      if (!this.old_order_number) {
        this.orderError = "Old order number is required";
        isValid = false;
      } else if (this.old_order_number.trim().length === 0) {
        this.orderError = "Old order number cannot be empty";
        isValid = false;
      }

      // Show error banner if validation fails
      if (!isValid) {
        this.showErrorBanner = true;
        // Scroll to top to show error banner
        window.scrollTo({ top: 0, behavior: "smooth" });
      }

      return isValid;
    },

    clearEmailError() {
      this.emailError = "";
    },

    clearZipError() {
      this.zipError = "";
    },

    clearLicensePlate1Error() {
      this.licensePlate1Error = "";
    },

    clearSeniorError() {
      this.seniorError = "";
    },

    clearOrderError() {
      this.orderError = "";
    },
    async handleOrderLookupBySerial() {
      this.isSubmitting = true;
      try {
        var settings = {
          url: `https://trailwaze.info/parkspass/api/getPassData_search.php?barcode=${this.old_order_number}`,
          method: "GET",
          timeout: 0,
          headers: {
            PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
          },
        };
        var _this = this;
        $.ajax(settings).done(function (response) {
          console.log(response);
          if (response.response == "SUCCESS") {
            // process response data
            _this.pass = response.data[0];
            // show results
            _this.searchResults = true;
          } else {
            // handle error
            console.error("Error looking up order:");
            _this.noSearchResults = true;
            _this.orderError =
              "Could not find order. Please check your order number and try again.";
          }
        });
      } catch (error) {
        console.error("Error looking up order:", error);
        this.showErrorBanner = true;
        this.orderError =
          "Could not find order. Please check your order number and try again.";
      } finally {
        this.isSubmitting = false;
      }
    },
    async handleOrderLookupByOrderNum() {
      // Validate order form

      this.isSubmitting = true;

      try {
        // TODO: Add your API call here to lookup the order
        // For example:
        // const response = await this.lookupOrder(this.old_order_number);
        var settings = {
          url: `https://trailwaze.info/parkspass/api/getPassData_search.php?order_number=${this.old_order_number}`,
          method: "GET",
          timeout: 0,
          headers: {
            PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
          },
        };
        var _this = this;
        $.ajax(settings).done(function (response) {
          console.log(response);
          if (response.response == "SUCCESS") {
            // process response data
            _this.pass = response.data[0];
            // show results
            _this.searchResults = true;
          } else if (response.response == "NO RESULTS") {
            // try to lookup by serial number
            console.log("no results, trying serial number");
            _this.handleOrderLookupBySerial();
          } else {
            // handle error
            console.error("Error looking up order:");
            _this.showErrorBanner = true;
            _this.orderError =
              "Could not find order. Please check your order number and try again.";
          }
        });

        // Placeholder - remove this and implement your actual lookup logic
        console.log("Looking up order:", this.old_order_number);

        // After successful lookup, you might want to:
        // 1. Load the saved license plates
        // 2. Navigate to a confirmation screen
        // 3. Show the saved data to the user
      } catch (error) {
        console.error("Error looking up order:", error);
        this.showErrorBanner = true;
        this.orderError =
          "Could not find order. Please check your order number and try again.";
      } finally {
        this.isSubmitting = false;
      }
    },
    prefill() {
      console.log("prefilling data: ", this.pass);
      this.license_plate1 = this.pass.license_plate;
      this.license_plate2 = this.pass.license_plate2;
      this.license_plate3 = this.pass.license_plate3;
      this.oldFound = true;
    },
    async handleSubmit() {
      // Validate form
      if (!this.validateForm()) {
        return;
      }

      this.isSubmitting = true;

      // prepare info for registration
      // register the pass
      // serial number
      this.serial_number = "SNOW0" + this.serial_number;
      console.log("adjusted serial number: ", this.serial_number);
      this.checkSale();
    },
    checkRegistration() {
      var _this = this;
      var settings = {
        url: `https://trailwaze.info/parkspass/api/getPassData_search.php?barcode=${this.serial_number}`,
        method: "GET",
        timeout: 0,
        headers: {
          PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
        },
      };
      $.ajax(settings)
        .done(function (response) {
          console.log("response: ", response);
          if (response.response == "SUCCESS") {
            console.log("already registered");
            console.log(response.data[0]);
            _this.pass = response.data[0];

            const createdDate = new Date(_this.pass.date_created);

            // Step 1: Move to the first day of the next month
            const expirationDate = new Date(createdDate);
            expirationDate.setDate(1); // force to day 1
            expirationDate.setMonth(expirationDate.getMonth() + 1); // next month

            // Step 2: Add one year
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);

            // Format the date
            const options = { year: "numeric", month: "short", day: "numeric" };
            _this.pass.expiration = expirationDate.toLocaleDateString(
              "en-US",
              options
            );

            console.log("pass with expiration:", _this.pass);

            // show the registered page
            _this.registered = true;

            // get history
            _this.GetHistory(_this.pass.order_number);
          } else {
            // show the registration page
            console.log("not registered yet");
            _this.registered = false;
            // then register
            _this.submitRegistration();
          }
        })
        .fail(function (error) {
          console.error("Error checking registration status:", error);
          // Optionally show error to user
        });
    },
    grabRegistration(order_num) {
      var _this = this;
      var settings = {
        url: `https://trailwaze.info/parkspass/api/getPassData_search.php?order_number=${order_num}`,
        method: "GET",
        timeout: 0,
        headers: {
          PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
        },
      };
      $.ajax(settings)
        .done(function (response) {
          console.log("response: ", response);
          if (response.response == "SUCCESS") {
            console.log("already registered");
            console.log(response.data[0]);
            _this.pass = response.data[0];

            const createdDate = new Date(_this.pass.date_created);

            // Step 1: Move to the first day of the next month
            const expirationDate = new Date(createdDate);
            expirationDate.setDate(1); // force to day 1
            expirationDate.setMonth(expirationDate.getMonth() + 1); // next month

            // Step 2: Add one year
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);

            // Format the date
            const options = { year: "numeric", month: "short", day: "numeric" };
            _this.pass.expiration = expirationDate.toLocaleDateString(
              "en-US",
              options
            );

            console.log("pass with expiration:", _this.pass);

            // show the registered page
            _this.registered = true;

            // get history
            _this.GetHistory(_this.pass.order_number);
          } else {
            // show the registration page
            console.log("not registered yet");
            _this.registered = false;
            // then register
            _this.submitRegistration();
          }
        })
        .fail(function (error) {
          console.error("Error checking registration status:", error);
          // Optionally show error to user
        });
    },
    IsItRegistered() {
      var _this = this;
      var settings = {
        url: `https://trailwaze.info/parkspass/api/getPassData_search.php?barcode=${this.serial_number}`,
        method: "GET",
        timeout: 0,
        headers: {
          PARKSPLUS_AUTH: "d1f713f7-0050-4c7c-ad9f-463630dc46a0",
        },
      };

      $.ajax(settings)
        .done(function (response) {
          console.log("response: ", response);
          if (response.response == "SUCCESS") {
            console.log(response.data[0]);
            _this.pass = response.data[0];

            const createdDate = new Date(_this.pass.date_created);

            // Step 1: Move to the first day of the next month
            const expirationDate = new Date(createdDate);
            expirationDate.setDate(1); // force to day 1
            expirationDate.setMonth(expirationDate.getMonth() + 1); // next month

            // Step 2: Add one year
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);

            // Format the date
            const options = { year: "numeric", month: "short", day: "numeric" };
            _this.pass.expiration = expirationDate.toLocaleDateString(
              "en-US",
              options
            );

            console.log("pass with expiration:", _this.pass);

            // show the registered page
            _this.registered = true;

            // get history
            _this.GetHistory(_this.pass.order_number);
          } else {
            // show the registration page
            _this.registered = false;
            // not registered, need to check if the range is in this years serial number range
            // _this.checkIfOnlineOrInPerson();
          }
        })
        .fail(function (error) {
          console.error("Error checking registration status:", error);
          // Optionally show error to user
        });
    },
  },
};
</script>

<style scoped>
#no-stamps {
  color: #3c3438;
  text-align: center;
  font-family: Roboto;
  font-size: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  padding-bottom: 20px;
}
.stamp-date {
  color: #212120;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding-top: 10px;
}
.stamp {
  width: 169px;
}
.stamp-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 35px;
}
.stamp-divider {
  stroke-width: 1px;
  stroke: #000;
  width: 388px;
  margin: 10px 0px;
}
#right {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 30px;
}
#right > h1 {
  color: #212120;
  text-align: center;
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px; /* 115% */
  letter-spacing: 0.1px;
}
#right > p {
  color: #212120;
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 111.111% */
  letter-spacing: 0.1px;
}
#deeplink-cont {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  padding: 30px 10px;
  border-radius: 8px;
  border: 1px solid #b1b1b1;
  background: #f9f9f9;
  width: 80%;
}
#deeplink-head {
  color: #212121;
  text-align: center;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
#deeplink-p {
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 140% */
}
#deeplink-button {
  color: #fff;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 50px;
  border: 1px solid #727a35;
  background: #727a35;
  padding: 10px 25px;
}
#info-p {
  color: #212120;
  text-align: center;
  font-family: Roboto;
  font-size: 26px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
  padding-left: 70px;
  padding-right: 70px;
  padding-top: 15px;
}
.app-cont {
  padding: 17px 80px;
  width: 350px;
  margin-bottom: 20px;
  border-radius: 8px;
  border: 1px solid #b1b1b1;
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#bottom-h1 {
  color: #212120;
  text-align: center;
  font-family: Roboto;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px; /* 115% */
  letter-spacing: 0.2px;
  margin: 20px 10px 40px;
}
#bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url("../assets/images/TOP-back.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-bottom: 100px;
  padding-top: 50px;
}
.dialog-h2 {
  color: #000;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 133.333% */
}
.dialog-h6 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-bottom: 0px;
  margin-left: 10px;
}
.bolded {
  font-weight: 700 !important;
}
.green-text {
  color: #727a35;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 133.333% */
  padding-left: 10px;
  margin-bottom: 0;
}
.side-flex {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.dialog-class {
  width: 65% !important;
}
.flex-end {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  cursor: pointer;
}
.info-card {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
  padding: 20px;
}
#dialog-cont {
  padding: 20px 30px;
}
.after-registration {
  display: flex;
  align-items: flex-start;
}
#left {
  min-height: 100vh; /* Ensures left has minimum height */
}
#right {
  width: 34%;
  height: 100vh; /* Fixed height matching viewport */
  overflow-y: auto;
  position: sticky;
  top: 0;
}
#top {
  background: #f9f9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 50px;
}
#bottom {
}

.page-cont {
  background-color: #f5f5f5;
}
.registration {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
}
.full-screen {
  height: 100vh;
}
.registration-inside {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.box {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
  padding: 32px;
  margin-bottom: 20px;
  width: 80%;
  max-width: 700px;
}
.box-image {
  display: flex;
  align-items: center;
}
h1 {
  color: #000;
  font-family: Roboto;
  font-size: 36px;
  font-style: normal;
  font-weight: 400;
  line-height: 36px;
}
p {
  color: #000;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
}
h2 {
  color: #000;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin-bottom: 10px;
}
.select-radio {
  color: #000;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
h6 {
  color: var(--material-theme-sys-light-on-background, #212121);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
}
.green-button {
  border-radius: 29px;
  background: #717638;
  color: #fff;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  padding: 10px 18px;
  border: none;
  cursor: pointer;
  transition: background 0.3s ease;
}
.green-button:hover:not(:disabled) {
  background: #5f6330;
}
.green-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.button-cont {
  display: flex;
  justify-content: flex-end;
}
.box-clear {
  margin-bottom: 20px;
  width: 80%;
  max-width: 700px;
}

.reg-textfield.v-text-field.v-text-field--enclosed,
.reg-textfield.v-input {
  margin: 15px 0px 0px !important;
  padding: 0 !important;
  width: 350px;
}
#error-message {
  color: #5a1213;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  margin-left: 10px;
}
.info-card {
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
  padding: 40px;
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.dialog-header h1 {
  margin: 0;
  font-size: 36px;
  line-height: 44px;
  font-weight: 400;
}

.close-icon {
  cursor: pointer;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.dialog-subtitle {
  font-size: 18px;
  line-height: 28px;
  margin-bottom: 24px;
  margin-top: 0;
}

.search-field-container {
  display: flex;
  align-items: center;
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 50px;
  padding: 8px 8px 8px 20px;
  margin-bottom: 24px;
  height: 56px;
  gap: 12px;
}

.search-icon-left {
  color: #666 !important;
  font-size: 24px !important;
  flex-shrink: 0;
}

.search-input-inline {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-family: Roboto;
  font-size: 16px;
  color: #000;
  height: 100%;
  min-width: 0;
}

.search-input-inline::placeholder {
  color: #999;
  font-size: 16px;
}

.search-button-inline {
  border-radius: 50px;
  background: #8b9456;
  color: #fff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: 500;
  padding: 10px 32px;
  border: none;
  cursor: pointer;
  transition: background 0.3s ease;
  white-space: nowrap;
  height: 40px;
  flex-shrink: 0;
}

.search-button-inline:hover:not(:disabled) {
  background: #727a35;
}

.search-button-inline:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #a8b076;
}

.search-error {
  color: #d0021b;
  font-family: Roboto;
  font-size: 14px;
  margin-top: -16px;
  margin-bottom: 16px;
}

.info-text {
  margin-top: 8px;
}

.info-line {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 4px;
  color: #000;
  margin-top: 0;
}

.info-label {
  font-weight: 700;
  color: #000;
}
.bolded {
  font-weight: 700;
}
.heavy {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 100% */
}
.heavy-2 {
  color: #212121;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 100% */
}
.green-heavy {
  color: #727a35;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px; /* 111.111% */
  margin-bottom: 0px;
  margin-left: 10px;
}
#result-box {
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}
#result-head {
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #585858;
  background: #f5f5f5;
  padding: 15px 20px;
}
#result-body {
  padding: 0 20px 20px 20px;
  display: flex;
  flex-direction: column;
}
.center-flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 40px 20px;
}
#no-search-h2 {
  color: #212121;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 100% */
  margin-bottom: 8px;
  margin-top: 20px;
}
#no-search-h5 {
  color: #212121;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
}
.plate-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.plate-row:last-child {
  border-bottom: none;
}

.plate-row:hover {
}

.plate-text {
  color: #000;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
  width: 200px;
}

.plate-action {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-icon {
  width: 20px;
  height: 20px;
}

.action-text {
  color: #727a35;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
}

.action-text-selected {
  color: #000;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  margin: 0;
}
#top > h1 {
  color: #212120;
  text-align: center;
  font-family: Roboto;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px; /* 100% */
}
#top > p {
  color: #3c3438;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 166.667% */
}
#top-divider {
  stroke-width: 1px;
  stroke: #000;
  width: 388px;
  margin: 10px 0px;
  background: #000;
}
#top > div > h3 {
  color: #212120;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 125% */
}
#bold-top {
  color: #212120;
  font-family: "Roboto-Mono";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  margin-right: 7px;
}
#top-check {
  margin-bottom: 20px;
}
.copy-button {
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.4px;
  border-radius: 23px;
  background: #727a35;
  padding: 4px 12px;
  display: flex;
  gap: 5px;
}
.custom-error-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ec8183;
  border: 1px solid #5a1213;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 0;
}

.error-content {
  display: flex;
  align-items: center;
  flex: 1;
}

.error-icon {
  color: #5a1213 !important;
  font-size: 20px !important;
  margin-right: 8px;
}

.error-text2 {
  color: #5a1213;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  padding-top: 0px;
}

.close-icon {
  color: #5a1213 !important;
  font-size: 20px !important;
  cursor: pointer;
  margin-left: 16px;
}

.close-icon:hover {
  opacity: 0.7;
}
@media only screen and (max-width: 768px) {
  .info-card {
    padding: 24px;
  }

  .dialog-header h1 {
    font-size: 28px;
    line-height: 36px;
  }

  .search-field-container {
    height: 48px;
  }

  .search-button-inline {
    padding: 8px 24px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 550px) {
  .box {
    width: 90%;
    margin: 0px 17px 20px;
    padding: 16px;
  }
  .box-clear {
    width: 90%;
    margin: 0px 17px 20px;
  }
  h1 {
    font-size: 28px;
    margin-bottom: 8px;
  }
  p {
    font-size: 16px;
    line-height: 24px;
  }
  h2 {
    font-size: 22px;
    line-height: 22px;
    margin-bottom: 8px;
  }
  h6 {
    font-size: 14px;
  }
  .reg-textfield.v-text-field.v-text-field--enclosed,
  .reg-textfield.v-input {
    width: unset;
  }
  .side-flex {
    align-items: flex-start;
  }
  .add-icon {
    padding-top: 3px;
  }
  #dialog-cont {
    padding: 0px 0px;
  }
  .plate-row {
    flex-direction: column;
    align-items: flex-start;
    border-bottom: 1px solid #c0c0c0;
  }
  .plate-row > div {
    margin-top: 10px;
  }
  .after-registration {
    flex-direction: column;
  }
  #left,
  #right {
    width: 100%;
  }
  #top {
    padding: 50px 30px 0px;
  }
  #top-divider {
    width: 100%;
  }
  #top > h1 {
    margin-bottom: 15px;
  }
  #top > div > h3 {
    color: #212120;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; /* 150% */
  }
  #bold-top {
    color: #212120;
    font-family: "Roboto-Mono";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
  }
  #stamp-divider {
    width: 100%;
  }
  .app-cont {
    width: 90%;
  }
  #right {
    height: unset;
  }
  #info-p {
    color: #000;
    text-align: center;
    font-family: Roboto;
    font-size: 26px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; /* 138.462% */
    padding: 0px 17px;
  }
  .box-image {
    flex-direction: column;
  }
}
@media only screen and (max-width: 320px) {
  h1 {
    font-size: 24px;
    margin-bottom: 0px;
  }
  #top > div > h3 {
    color: #212120;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; /* 150% */
  }
  #bold-top {
    color: #212120;
    font-family: "Roboto-Mono";
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
  }
}
</style>

<style>
.select-radio > .v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  color: #000;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.v-radio {
  align-items: flex-start !important;
}

/* Make error messages red */
.v-text-field.error--text .v-messages__message,
.v-input.error--text .v-messages__message {
  color: #d0021b !important;
}

/* Keep hint text black when there's no error */
.v-text-field:not(.error--text) .v-messages__message {
  color: #000 !important;
}

/* Make error label text red */
.v-text-field.error--text .v-label,
.v-input.error--text .v-label {
  color: #d0021b !important;
}

/* Make error border red for text fields */
.v-text-field.error--text fieldset {
  border-color: #d0021b !important;
}

.v-text-field.error--text .v-input__slot {
  border-color: #d0021b !important;
}

/* Ensure error messages are red, but hints stay black */
.v-text-field.error--text .v-messages__message,
.v-input.error--text .v-messages__message {
  color: #d0021b !important;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: 0.4px;
}
/* Make the underline red when there's an error */
.v-text-field.error--text .v-input__slot:before {
  border-color: #d0021b !important;
}

.v-text-field.error--text .v-input__slot:after {
  border-color: #d0021b !important;
}

/* For filled text fields - make the bottom border red */
.v-text-field.v-text-field--filled.error--text
  > .v-input__control
  > .v-input__slot:before {
  border-color: #d0021b !important;
}

.v-text-field.v-text-field--filled.error--text
  > .v-input__control
  > .v-input__slot:after {
  border-color: #d0021b !important;
}

/* Optional: Add a subtle red background tint to error fields */
.v-text-field.v-text-field--filled.error--text
  > .v-input__control
  > .v-input__slot {
  background: rgba(208, 2, 27, 0.05) !important;
}

.v-text-field:not(.error--text) .v-messages__message,
.v-input:not(.error--text) .v-messages__message {
  color: #000 !important;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px !important;
  letter-spacing: 0.4px;
}

/* Make radio group errors red */
.v-radio-group.error--text .v-messages__message {
  color: #d0021b !important;
}
.v-text-field--filled.v-input--is-focused .v-label {
  color: #727a35 !important;
}
.v-text-field--filled.v-input--is-focused
  > .v-input__control
  > .v-input__slot:after {
  border-color: #727a35 !important;
}

@media only screen and (max-width: 550px) {
  .select-radio > .v-input--selection-controls .v-input__slot > .v-label,
  .v-input--selection-controls .v-radio > .v-label {
    font-size: 16px;
    line-height: 24px;
  }
}
</style>
